import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyB0P1t3kONTalM_RVaoBWel0SAJVA-cvTQ",
  authDomain: "semillero-37755.firebaseapp.com",
  projectId: "semillero-37755",
  storageBucket: "semillero-37755.firebasestorage.app",
  messagingSenderId: "301983510571",
  appId: "1:301983510571:web:55daf37b3fe2ce7a3ffa6e",
  measurementId: "G-GV1NG5WP1Q"
};

export const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)